import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { Props } from './NoPermissionViews.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyNoPermissionViews = lazy(
	() =>
		import(
			/* webpackChunkName: "async-project-directory-no-permission-views" */ './NoPermissionViews.tsx'
		).then(({ NoPermissionViews }) => NoPermissionViews),
	{ ssr: false },
);

export const AsyncNoPermissionViews = (props: Props): React.JSX.Element => (
	<Placeholder name="no-permission-views" fallback={null}>
		<LazyNoPermissionViews {...props} />
	</Placeholder>
);
